import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { authService } from '@/api'
import { concluirPreloader, iniciarPreloader } from '@/store/preloader'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: '/abrir-caixa',
    name: 'abrir-caixa',
    component: () => import('@/views/AbrirCaixaView.vue')
  },
  {
    path: '/pos-loja/caixa',
    name: 'pos-loja-caixa',
    component: () => import('@/views/pos-loja/CaixaView.vue')
  },
  {
    path: '/pos-loja/cliente',
    name: 'pos-loja-cliente',
    component: () => import('@/views/pos-loja/ClienteView.vue')
  },
  {
    path: '/pos-restaurante/mesas',
    name: 'pos-restaurante-mesas',
    component: () => import('@/views/pos-restaurante/MesasView.vue')
  },
  {
    path: '/pos-restaurante/mesa/:codigo',
    name: 'pos-restaurante-mesa',
    component: () => import('@/views/pos-restaurante/MesaView.vue')
  },
  {
    path: '/pos-restaurante/cliente',
    name: 'pos-restaurante-cliente',
    component: () => import('@/views/pos-restaurante/ClienteView.vue')
  },
  {
    path: '/fechar-caixa',
    name: 'fechar-caixa',
    component: () => import('@/views/FecharCaixaView.vue')
  },
  {
    path: '/historico/caixa',
    name: 'historico-caixa',
    component: () => import('@/views/historico/CaixaView.vue')
  },
  {
    path: '/historico/facturas',
    name: 'historico-facturas',
    component: () => import('@/views/historico/FacturasView.vue')
  },
  {
    path: '/historico/levantar-cash',
    name: 'historico-levantar-cash',
    component: () => import('@/views/historico/LevantarCashView.vue')
  },
  {
    path: '/terminar-venda/cash',
    name: 'terminar-venda-cash',
    component: () => import('@/views/terminar-venda/CashView.vue')
  },
  {
    path: '/terminar-venda/cartao',
    name: 'terminar-venda-cartao',
    component: () => import('@/views/terminar-venda/CartaoView.vue')
  },
  {
    path: '/terminar-venda/misto',
    name: 'terminar-venda-misto',
    component: () => import('@/views/terminar-venda/MistoView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

function terminalDaRota(path: string): string | null {
  if (path.startsWith('/pos-loja')) return 'Loja'
  if (path.startsWith('/pos-restaurante')) return 'Restaurante'
  return null
}

function rotaHomeDoTerminal(terminal: string): string {
  return terminal === 'Restaurante' ? '/pos-restaurante/mesas' : '/pos-loja/caixa'
}

router.beforeEach(async to => {
  iniciarPreloader()

  if (to.name === 'login') {
    if (!authService.estaAutenticado()) return true

    const usuario = await authService.usuarioAutenticado()
    if (!usuario) return true

    return usuario.sessaoCaixa ? { path: rotaHomeDoTerminal(usuario.sessaoCaixa.terminal) } : { name: 'abrir-caixa' }
  }

  if (!authService.estaAutenticado()) {
    return { name: 'login' }
  }

  const usuario = await authService.usuarioAutenticado()

  if (!usuario) {
    return { name: 'login' }
  }

  const sessaoCaixa = usuario.sessaoCaixa

  if (!sessaoCaixa) {
    return to.name === 'abrir-caixa' ? true : { name: 'abrir-caixa' }
  }

  const terminalAlvo = terminalDaRota(to.path)
  const foraDoTerminalAberto = terminalAlvo !== null && terminalAlvo !== sessaoCaixa.terminal

  if (to.name === 'abrir-caixa' || foraDoTerminalAberto) {
    return { path: rotaHomeDoTerminal(sessaoCaixa.terminal) }
  }

  return true
})

router.afterEach(() => {
  concluirPreloader()
})

router.onError(() => {
  concluirPreloader()
})

export default router
